import React from 'react';
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import SimpleLookupManagement, { LookupField } from './SimpleLookupManagement';

const fields: LookupField[] = [
  { key: 'name', label: 'Name', required: true, helperText: 'e.g. "Wettable Granule"' },
  { key: 'acronym', label: 'Acronym', required: true, helperText: 'e.g. "WG"' },
];

const FormulationManagement: React.FC = () => (
  <SimpleLookupManagement
    title="Formulation Management"
    icon={<ScatterPlotIcon />}
    apiPath="/api/formulations"
    fields={fields}
    entityLabel="Formulation"
  />
);

export default FormulationManagement;
